import dayjs from "dayjs";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { serviceSalesApi } from "../api";
import { API_DATE_FORMAT } from "../../../../app_constants.js";

export const FETCH_CURRENT_USER = "saga/serviceSales/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/serviceSales/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/serviceSales/FETCH_CHART_SUCCESS";
export const FETCH_GRAPH_FAILURE = "saga/serviceSales/FETCH_GRAPH_FAILURE";
export const FETCH_FILTERS_SUCCESS = "saga/serviceSales/FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_FAILURE = "saga/serviceSales/FETCH_FILTERS_FAILURE";

export const UPDATE_GROUP_CATEGORY_SELECTED = "sagas/serviceSales/UPDATE_GROUP_CATEGORY_SELECTED";
export const UPDATE_COMPARE_DATES_SELECTED = "sagas/serviceSales/UPDATE_COMPARE_DATES_SELECTED";
export const UPDATE_TABLE_VIEW_SELECTED = "saga/serviceSales/UPDATE_TABLE_VIEW_SELECTED";
export const UPDATE_FILTERS_SUCCESS = "saga/serviceSales/UPDATE_FILTERS_SUCCESS";
export const UPDATE_FILTERS_FAILURE = "saga/serviceSales/UPDATE_FILTERS_FAILURE";
export const UPDATE_GROUP_CATEGORY = "sagas/serviceSales/UPDATE_GROUP_CATEGORY";
export const UPDATE_COMPARE_DATES = "sagas/serviceSales/UPDATE_COMPARE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/serviceSales/UPDATE_CUSTOM_RANGE";
export const UPDATE_COMPARE_TYPE = "sagas/serviceSales/UPDATE_COMPARE_TYPE";
export const UPDATE_PERIOD_TYPE = "sagas/serviceSales/UPDATE_PERIOD_TYPE";
export const UPDATE_CHART = "saga/serviceSales/UPDATE_CHART";
export const UPDATE_DATES = "saga/serviceSales/UPDATE_DATES";
export const UPDATE_PRIMARY_CATEGORY_SELECTED =
  "sagas/serviceSales/UPDATE_PRIMARY_CATEGORY_SELECTED";
export const UPDATE_SHOW_NET_REVENUE_SELECTED =
  "sagas/serviceSales/UPDATE_SHOW_NET_REVENUE_SELECTED";
export const UPDATE_SECONDARY_CATEGORY_SELECTED =
  "sagas/serviceSales/UPDATE_SECONDARY_CATEGORY_SELECTED";
const UPDATE_SECONDARY_CATEGORY = "sagas/serviceSales/UPDATE_SECONDARY_CATEGORY";
const UPDATE_PRIMARY_CATEGORY = "sagas/serviceSales/UPDATE_PRIMARY_CATEGORY";
const UPDATE_SHOW_NET_REVENUE = "sagas/serviceSales/UPDATE_SHOW_NET_REVENUE";
const UPDATE_TABLE_VIEW = "saga/serviceSales/UPDATE_TABLE_VIEW";

export const SET_PRIMARY_CATEGORIES_LOADING = "saga/serviceSales/SET_PRIMARY_CATEGORIES_LOADING";
export const SET_UPDATES_LOADING = "saga/serviceSales/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/serviceSales/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/serviceSales/SET_LOADING";
export const SET_DATES = "saga/serviceSales/SET_DATES";
export const SET_SECONDARY_CATEGORIES_LOADING =
  "saga/serviceSales/SET_SECONDARY_CATEGORIES_LOADING";

export const RESET_FILTER_SELECTED = "sagas/serviceSales/RESET_FILTER_SELECTED";
const RESET_FILTER = "sagas/serviceSales/RESET_FILTER";

export const USER_SELECT = "sagas/serviceSales/USER_SELECT";

const UPDATE_REVENUE_VIEW = "saga/serviceSales/UPDATE_REVENUE_VIEW";
export const UPDATE_REVENUE_VIEW_SELECTED = "saga/serviceSales/UPDATE_REVENUE_VIEW_SELECTED";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updatePrimaryCategory: createAction(UPDATE_PRIMARY_CATEGORY),
  updateSecondaryCategory: createAction(UPDATE_SECONDARY_CATEGORY),
  updateGroupCategory: createAction(UPDATE_GROUP_CATEGORY),
  updateShowNetRevenue: createAction(UPDATE_SHOW_NET_REVENUE),
  updateCompareDates: createAction(UPDATE_COMPARE_DATES),
  updateCompareType: createAction(UPDATE_COMPARE_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  resetFilters: createAction(RESET_FILTER),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updateRevenueView: createAction(UPDATE_REVENUE_VIEW)
};

export default function* watchServiceSales() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_PRIMARY_CATEGORY, updatePrimaryCategory);
  yield takeLatest(UPDATE_SECONDARY_CATEGORY, updateSecondaryCategory);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_SHOW_NET_REVENUE, updateShowNetRevenue);
  yield takeLatest(UPDATE_GROUP_CATEGORY, updateGroupCategory);
  yield takeLatest(UPDATE_COMPARE_DATES, updateCompareDates);
  yield takeLatest(UPDATE_REVENUE_VIEW, updateRevenueView);
}

function* updateRevenueView({ payload }) {
  yield put({ type: UPDATE_REVENUE_VIEW_SELECTED, payload });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  const endDate = yield select((state) => state.serviceSales.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);

  yield setDates(startDate, endDate);
  yield put({ type: RESET_FILTER_SELECTED });

  try {
    yield fetchFilters();
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  const endDate = yield select((state) => state.serviceSales.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);

  yield setDates(startDate, endDate);

  yield put({ type: RESET_FILTER_SELECTED });
  try {
    yield fetchFilters();
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateShowNetRevenue({ payload }) {
  yield put({ type: UPDATE_SHOW_NET_REVENUE_SELECTED, payload });
  yield updateData();
}

function* updateGroupCategory({ payload }) {
  yield put({ type: UPDATE_GROUP_CATEGORY_SELECTED, payload });
  yield updateData();
}

function* updateCompareDates({ payload }) {
  yield put({ type: UPDATE_COMPARE_DATES_SELECTED, payload });
  yield updateData();
}

export function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updatePrimaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload });

  yield updateFilters("Primary", payload);
}

function* updateSecondaryCategory({ payload }) {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
  yield put({ type: USER_SELECT, payload });
  yield updateFilters("Secondary", payload);
}

function* setDates(startDate, endDate) {
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

export function* fetchCurrentUserData({ payload }) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: payload }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  const endDate = yield select((state) => state.serviceSales.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);

  yield setDates(startDate, endDate);

  try {
    yield fetchFilters();
    yield fetchChart();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChart() {
  const params = yield getCommonApiParams();
  const selectedView = yield select((state) => state.serviceSales.selectedRevenueView);
  const filterParams = yield select((state) => state.serviceSales.selectedFilters);
  const isRevenueCategoryView = selectedView.id === "revenue_category";

  const allowedKeys = isRevenueCategoryView
    ? Object.keys(filterParams)
    : ["period_type", "table_view", "include_returns"];

  const filteredParams = {};
  allowedKeys.forEach((key) => {
    filteredParams[key] = filterParams[key];
  });

  const filterQueryParams = Object.keys(filteredParams).map((paramKey) => {
    const value = filteredParams[paramKey];
    if (Array.isArray(value) && value.length > 0) {
      return { [paramKey]: value.map((val) => val.id).join(",") };
    } else if (typeof value === "object" && value.id) {
      return { [paramKey]: value.id };
    } else {
      return {
        [paramKey]: typeof value === "string" ? value.toLowerCase() : value
      };
    }
  });

  filterQueryParams.push({ view: selectedView.id });

  yield getServiceSalesChart(params, filterQueryParams);
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const { startDate, endDate } = yield select((state) => state.serviceSales.selectedRequestDates);

  return {
    organization_id,
    short_url,
    start_date: startDate,
    end_date: endDate
  };
}

export function* fetchFilters() {
  const params = yield getCommonApiParams();
  const selectedView = yield select((state) => state.serviceSales.selectedRevenueView);

  yield getServiceSalesFilters({ ...params, view: selectedView.id });
}

export function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateFilters(name, payload) {
  const { organization_id, short_url } = yield getCommonApiParams();

  const values = payload.map((p) => p.id).join(",");
  if (name === "Primary") {
    yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: true });
    yield getServiceSalesRevenueCategories({ organization_id, short_url }, true, values);
  }
  if (name === "Secondary") {
    yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: true });
    yield getServiceSalesRevenueCategories({ organization_id, short_url }, false, values);
  }
}

function* getServiceSalesChart(commonParams, filterQueryParams = "") {
  const filters = Object.assign({}, ...filterQueryParams);

  try {
    const response = yield call([serviceSalesApi, serviceSalesApi.getChart], {
      ...commonParams,
      ...filters
    });

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GRAPH_FAILURE, error });
  }
}

function* getServiceSalesFilters(params) {
  try {
    const response = yield call([serviceSalesApi, serviceSalesApi.getFilters], params);

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });

    const {
      primary_categories = [],
      secondary_categories = [],
      start_date,
      end_date
    } = response.data.filters || {};
    yield put({ type: UPDATE_PRIMARY_CATEGORY_SELECTED, payload: primary_categories });
    yield put({ type: UPDATE_SECONDARY_CATEGORY_SELECTED, payload: secondary_categories });

    yield setDates(start_date, end_date);
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}

function* getServiceSalesRevenueCategories(commonParams, isPrimary, categoryValues) {
  try {
    const response = yield call([serviceSalesApi, serviceSalesApi.getRevenueCategories], {
      ...commonParams,
      [isPrimary ? "primary_categories" : "secondary_categories"]: categoryValues
    });
    if (isPrimary) {
      yield put({ type: SET_SECONDARY_CATEGORIES_LOADING, payload: false });
      yield put({
        type: UPDATE_SECONDARY_CATEGORY_SELECTED,
        payload: response.data.secondary_categories
      });
    } else {
      yield put({ type: SET_PRIMARY_CATEGORIES_LOADING, payload: false });
      yield put({
        type: UPDATE_PRIMARY_CATEGORY_SELECTED,
        payload: response.data.primary_categories
      });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FILTERS_FAILURE, error });
  }
}
